import {queryOptions} from '@tanstack/react-query';
import {fetchBillingPlans} from './fetchBillingPlans';

export const billingPlansQuery = queryOptions({
  queryFn: fetchBillingPlans,
  queryKey: ['billing', 'plans'],
});
